import PropTypes from "prop-types";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

import styles from "./PassportAdminReviewItem.module.css";

export default function PassportAdminReviewItem({
  info,
  onView,
  even = false,
}) {
  return (
    <div
      className={classNames(styles.reviewItemRow, {
        [styles.even]: even,
      })}
    >
      {/* Name */}
      <div className={styles.col} data-label="Name">
        <a className={styles.link} onClick={onView}>
          {info.name}
        </a>
      </div>

      {/* Verified */}
      <div
        className={classNames(styles.col, styles.center)}
        data-label="Verified"
      >
        {info.VerificationComplete && (
          <span
            data-tooltip-id="my-tooltip"
            data-tooltip-type={info.VerifiedByType}
          >
            <FontAwesomeIcon
              icon={faCheck}
              className={styles.verifiedIcon}
            />
          </span>
        )}
      </div>

      {/* Status */}
      <div className={styles.col} data-label="Status">
        <span
          className={classNames(
            styles.statusBadge,
            {
              [styles.review]:
                info.reviewStatus?.toLowerCase() === "review",

              [styles.pending]:
                info.reviewStatus?.toLowerCase() === "pending",

              [styles.approved]:
                info.reviewStatus?.toLowerCase() === "approved",

              [styles.rejected]:
                info.reviewStatus?.toLowerCase() === "rejected",
            }
          )}
        >
          {info.reviewStatus || ""}
        </span>
      </div>

      {/* Program */}
      <div className={styles.col} data-label="Program">
        {info.program || ""}
      </div>

      {/* School */}
      <div className={styles.col} data-label="School">
        {info.school || ""}
      </div>

      {/* SID */}
      <div className={styles.col} data-label="SID / EID">
        {info.sid || ""}
      </div>

      {/* View */}
      <div
        className={classNames(styles.col, styles.center)}
        data-label="View"
      >
        <button
          type="button"
          className={styles.button}
          onClick={onView}
        >
          View
        </button>
      </div>
    </div>
  );
}

PassportAdminReviewItem.propTypes = {
  info: PropTypes.shape({
    name: PropTypes.string,
    sid: PropTypes.string,
    school: PropTypes.string,
    program: PropTypes.string,
    reviewStatus: PropTypes.string,
    VerificationComplete: PropTypes.bool,
    VerifiedByType: PropTypes.string,
  }).isRequired,

  onView: PropTypes.func,

  even: PropTypes.bool,
};